angular.module( 'acme.view.application.account.administration.emailLanguage', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.account.administration.emailLanguage.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var accountAdministrationEmailLanguage = {
        name: 'application.account.administration.emailLanguage',
        url: '/account/administration/emailLanguage',
        views: {
          "main": {
            controller: 'AccountAdministrationEmailLanguageController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/account/administration/emailLanguage/emailLanguage.tpl.html'
          }
        },
        data: {
          pageTitle: '   ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(accountAdministrationEmailLanguage);
});
